import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import { EVENT } from './utils/constants'
import 'vuetify/dist/vuetify.min.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/index.scss'
import './plugins/vue-toast'
import './plugins/clipboard'
import './plugins/services'
import './plugins/tiptap'
import Modal from '~/plugins/modal.js'
import VueExcelXlsx from "vue-excel-xlsx";


Vue.config.productionTip = false

const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus
Vue.prototype.$loading = {
  start() {
    eventBus.$emit(EVENT.LOADING, true)
  },
  finish() {
    eventBus.$emit(EVENT.LOADING, false)
  }
}
Vue.use(Modal)
Vue.use(VueExcelXlsx);
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
